import { TableHeaderWrapper } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetails/InvestorDetails';
import { RemoveInvestorBox } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetails/components/RemoveInvestorBox';
import { useManageInvestorSectionController } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetails/components/useManageInvestorSectionController';
import {
	AlertDescription,
	AlertTitle,
	Alert,
} from '@dealstack/frontend/shared/components/Alert/Alert';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import styled from 'styled-components';

interface Props {
	className?: string;
	navigateToTable: () => void;
	investorId?: string;
}

const ManageInvestorSection = ({ className, navigateToTable, investorId }: Props) => {
	const tMipManage = useTranslationMipManage();
	const { removeInvestor } = useManageInvestorSectionController(navigateToTable, investorId);

	const TableHeader = (
		<Text variant="sans/17/800" disableVariantMapping>
			{tMipManage('investors.expanded_row.manage_investor.title')}
		</Text>
	);
	return (
		<div className={className}>
			<TableHeaderWrapper>{TableHeader}</TableHeaderWrapper>
			<Alert icon="information-filled" state="info" size="s">
				<AlertTitle>
					{tMipManage('investors.expanded_row.manage_investor.alert_title')}
				</AlertTitle>
				<AlertDescription>
					{tMipManage('investors.expanded_row.manage_investor.alert_description')}
				</AlertDescription>
			</Alert>
			<RemoveInvestorBox
				checkboxText={tMipManage(
					'investors.expanded_row.manage_investor.remove_investor_description'
				)}
				buttonText={tMipManage(
					'investors.expanded_row.manage_investor.remove_investor_button'
				)}
				buttonAction={removeInvestor}
			/>
		</div>
	);
};
const Styled = styled(ManageInvestorSection)`
	${Alert} {
		margin-bottom: 1rem;
	}
`;

export { Styled as InvestorSection };
